import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectTurnOnTheStoreChainLinkFeature } from '@us/web/shop/data-access';
import { filter, map, of, switchMap } from 'rxjs';
import { tuiIsPresent } from '@taiga-ui/cdk';
import { RouteUtil } from '@us/web/shared/utils';
import { selectSelectedShopId } from '@us/web/shops/data-access';

@Injectable({
    providedIn: 'root'
})
export class RouteService {
    private readonly store = inject(Store);

    readonly homePageUrl$ = this.store.select(selectTurnOnTheStoreChainLinkFeature).pipe(
        filter(tuiIsPresent),
        switchMap(turnOnTheStoreChainLinkFeature => {
            if (!turnOnTheStoreChainLinkFeature) {
                return of(RouteUtil.getHomeRouteUrl());
            }

            return this.store.select(selectSelectedShopId).pipe(
                filter(tuiIsPresent),
                map(id => RouteUtil.getShopRouteUrl(id))
            );
        })
    );
}
